const state = {
  campaigns: [],
  serviceName: 'campaigns',
};

const getters = {
  getCampaignById: (state) => (id) => {
    return state.campaigns.find((campaign) => campaign.id === id);
  },
};

const actions = {
  async fetchCampaigns(context, opts = { active: true, sort: 'name' }) {
    const { active = true, sort = 'name' } = opts;

    const { campaigns } = await this.$services
      .resource(context.state.serviceName)
      .get({ sort, 'filter[active]': active })
      .then((res) => res.data.data);

    context.commit('SET_CAMPAIGNS', campaigns);

    return campaigns;
  },
};

const mutations = {
  SET_CAMPAIGNS(state, campaigns) {
    state.campaigns = campaigns;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
